import React, { useState, useEffect } from 'react';
import { displayLoader } from '../../utils';
import { DataTable } from '../dataTable';


/**
 * Standings Table
 */
const StandingsAndBracket = (props) => {
    const { 
        standings = null, 
        season = null, 
        showTitle = false,
        title = null,
        highlight = null,
        clubData = null,
        ...restProps 
    } = props;

    const [ isBracket, setIsBracket ] = useState(false);
    const [ bracketImage, setBracketImage ] = useState(false);
    const [ titleStr, setTitleStr ] = useState(null);

    /**
     * Season information
     */
    useEffect(()=> {
        if ( !season ) return;

        if ( season.type == 'bracket' ) {
            setIsBracket(true);
            setTitleStr(title ? title : 'Bracket');
            if ( season.hasOwnProperty('bracket_chart') && season.bracket_chart ) {
                setBracketImage(season.bracket_chart);
            } else {
                setBracketImage(false);
            }
        } else {
            setTitleStr(title ? title : 'Overall Standings');
        }

    }, [season]);

    /**
     * Calculate Standings (add any extra parameters needed)
     */
    useEffect(() => {
        if ( !standings ) {
            return;
        }

        standings.map((standing) => {
            // Add GD stat
            standing.gd = standing.hasOwnProperty('goalsFor') && standing.hasOwnProperty('goalsAgainst') ? standing.goalsFor - standing.goalsAgainst : '';
            return standing;
        });

    }, [standings]);


    // Return nothing if we don't have any data yet
    // if ( !isLoaded ) return;
    if ( !standings && !bracketImage ) return;

    // Else return either the standings or the bracket image
    return (
        <>
            { isBracket ? (
                <div className="acaStandings acaStandings--bracket">
                    { showTitle ? (
                        <h2 className="acaH1 acaStandings__title">{titleStr}</h2>
                    ) : '' }
                    { bracketImage ? (
                        <img src={bracketImage} className="acaBracket" />
                    ) : '' }
                </div>
            ) : (
                <div className="acaStandings acaStandings--table">
                    { showTitle ? (
                        <h2 className="acaH1 acaWrapper acaWrapper--withPadding acaStandings__title">{titleStr}</h2>
                    ) : '' }
                    <div className="acaTable__mobileLabel">
                        Scroll to the left to see full chart
                    </div>
                    <div className="acaWrapper acaWrapper--withPadding paddingTop--extraSmall">
                        <DataTable
                            fields = {[
                                {
                                    key: 'position',
                                    label: 'Pos',
                                    center: true,
                                    size: 'small'
                                },
                                {
                                    key: 'club',
                                    label: 'Team Name',
                                    border: true
                                },
                                {
                                    key: 'matches',
                                    label: 'MP',
                                    center: true,
                                    size: 'small',
                                    border: true,
                                    grey: true
                                },
                                {
                                    key: 'wins',
                                    label: 'W',
                                    center: true,
                                    size: 'small',
                                    grey: true
                                },
                                {
                                    key: 'losses',
                                    label: 'L',
                                    center: true,
                                    size: 'small',
                                    grey: true
                                },
                                {
                                    key: 'draws',
                                    label: 'T',
                                    center: true,
                                    size: 'small',
                                    grey: true
                                },
                                {
                                    key: 'points',
                                    label: 'Pts',
                                    center: true,
                                    size: 'small',
                                    grey: true
                                },
                                {
                                    key: 'goalsFor',
                                    label: 'GF',
                                    center: true,
                                    size: 'small',
                                    grey: true
                                },
                                {
                                    key: 'goalsAgainst',
                                    label: 'GA',
                                    center: true,
                                    size: 'small',
                                    grey: true
                                },
                                {
                                    key: 'gd',
                                    label: 'GD +/-',
                                    center: true,
                                    size: 'small',
                                    grey: true
                                }
                            ]}
                            data={standings}
                            highlight={highlight}
                            extraData={clubData}
                        />
                    </div>
                </div>
            ) }
        </>
    );
}


export { StandingsAndBracket };